module.exports = "<div class=\"kl-layout {class}\" r-class=\"{ { 'is-vertical': isVertical, 'is-master': isMaster } }\">\n    {#inc this.$body}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLLayout/index.html
// module id = 561
// module chunks = 0